import { Box, useMediaQuery } from "@mui/material";
import imgFuncionarioEnergia from "../../../../assets/images/servicos/energia/ENERGIA_banner_2.png";
import imgBannerMobile from "../../../../assets/images/servicos/energia/ENERGIA_banner_mobile.png";
import bgPersonal from "../../../../assets/images/servicos/energia/ENERGIA_personal.png";
import logoPersonalEnergia from "../../../../assets/images/servicos/energia/logo_personal_energia.png";
import DefaultText from "../../../../components/typography/default-text";
import styles from "./styles.module.css";

const Energia = () => {

  const vw1024 = useMediaQuery('(max-width: 1024px)');
  const isMobileBanner = useMediaQuery('(max-width: 989px)');

  return (
    <>
      <div className={styles["sub-page-content"]} style={{ justifyContent: "center" }}>
        <img
          src={isMobileBanner ? imgBannerMobile : imgFuncionarioEnergia}
          className={styles["energy-image"]}
          alt={isMobileBanner ? "Funcionário da Telemont com capacete de segurança" : "Imagem de vários funcionários da empresa Telemont"}
        />
      </div>
      <div 
        className={styles["sub-page-content-grey"]} 
        style={{ 
          backgroundColor: "var(--secondary-grey)",
          '--bg-image': `url(${bgPersonal})`
        } as React.CSSProperties}
      >
        <Box display={'flex'} flexDirection={'column'} gap={"24px"} width={'100%'} sx={{ position: 'relative', zIndex: 1 }}>
          <Box width={'100%'} display={'flex'} flexDirection={vw1024 ? 'column' : 'row'} gap={"24px"} justifyContent={'space-between'}>
            <Box display={'flex'} flexDirection={'column'} gap={"24px"} paddingLeft={"4vw"}>
               <DefaultText size="medium" lineHeight="var(--font-size-large)" className={styles["responsive-title"]}>
              A Personal é <br/>
              <span className={styles["responsive-title-bold"]}>
                mais energia
              </span>
            </DefaultText>
              <DefaultText size="small" maxWidth={"800px"} lineHeight="var(--font-size-large)">
              <div className={styles["text-container-desktop"]}>
                A Personal atua em várias frentes do segmento de energia, <br/>
                realizando serviços que possibilitam o pleno funcionamento <br/> 
                de milhares de residências e estabelecimentos comerciais. <br/>
                Tudo isso com segurança e qualidade, garantindo sempre um <br/>
                atendimento ágil e de excelência.
              </div>
              <div className={styles["text-container-mobile"]}>
                A Personal atua em várias frentes do <br/>
                segmento de energia, realizando <br/> 
                serviços que possibilitam o pleno <br/>
                funcionamento de milhares de <br/>
                residências e estabelecimentos <br/>
                comerciais. Tudo isso com segurança <br/>
                e qualidade, garantindo sempre um <br/>
                atendimento ágil e de excelência.
              </div>
            </DefaultText>
            </Box>
            <img src={logoPersonalEnergia} alt="Logo PERSONAL Energia" className={styles["personal-logo-image"]} />
          </Box>
          <div className={styles["solutions-grid"]}>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Construção e manutenção em <span className={styles["desktop-break"]}></span> Redes e Linha de Distribuição de <span className={styles["desktop-break"]}></span> Energia aéreas e subterrâneas, <span className={styles["desktop-break"]}></span> inclusive em linha viva;
              </DefaultText>
            </div>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Construção e manutenção de iluminação pública
              </DefaultText>
            </div>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Operação e restabelecimento em redes e linhas de distribuição de energia
              </DefaultText>
            </div>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Ligação, desligamento e <span className={styles["desktop-break"]}></span> religação de unidades <span className={styles["desktop-break"]}></span> consumidoras de energia
              </DefaultText>
            </div>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Inspeção de unidades <span className={styles["desktop-break"]}></span> consumidoras de energia
              </DefaultText>
            </div>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Serviços de instalação e <span className={styles["desktop-break"]}></span> manutenção de medição <span className={styles["desktop-break"]}></span> inteligente
              </DefaultText>
            </div>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Inspeções aéreas de redes de <span className={styles["desktop-break"]}></span> distribuição.
              </DefaultText>
            </div>
            <div className={styles["solutions-card"]}>
              <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500}}>
                Manutenção em equipamentos <span className={styles["desktop-break"]}></span> de subestações.
              </DefaultText>
            </div>
          </div>
        </Box>
      </div>
    </>
  );
};

export default Energia;
